import { ImageFilterBlackWhiteIcon } from './ImageFilterBlackWhiteIcon';

/**
 * author: Google
 * id 7D3932BA-9061-40D7-B624-044EE7A7B445
 * name image-filter-black-white
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-filter-black-white.svg
 * tags
 * - Photography 
 */
export const FilterBAndWIcon = ImageFilterBlackWhiteIcon;
export default FilterBAndWIcon